module.exports = __webpack_public_path__ + "static/media/Portfolio2.e83e09d8.jpg";